<template>
  <div>
    <van-nav-bar style="background-color: #42b983">
      <template #title>
        <span style="color: #ffffff">授权登陆</span>
      </template>
      <template #left>
        <router-link to="/">
          <van-icon name="arrow-left" color="#ffffff"/>
          <span style="color: #ffffff">返回</span>
        </router-link>
      </template>
      <template #right>
        <router-link to="/">
          <van-icon name="wap-home-o" color="#ffffff" size="1.3rem"/>
        </router-link>
      </template>
    </van-nav-bar>


    {{ message }}


  </div>
</template>

<script>

export default {
  data() {
    return {
      message: "",
      code: ""
    };
  },
  created() {
    this.code = this.$route.query.code
    this.login()
  },
  methods: {
    login() {
      this.loading = true;
      this.$http.get("/wechat/login", {
        params: {
          code: this.code
        }
      }).then(res => {
        try {
          if (3000 === res.data.code) {
            // this.message = "正在为您跳转到微信授权登陆·请稍后..."
            this.message = "加载中"
            window.location.href = res.data.data
          } else if (200 === res.data.code) {
            localStorage.setItem("token", res.data.data.token);
            //设置web日志监控的用户id
            if (undefined !== res.data.data.user && null !== res.data.data.user) {
              localStorage.setItem("user_id", res.data.data.user.id);
            }
            this.$router.push('/');
          } else {
            this.message = res.data.msg
          }
        } catch (err) {
          this.message ="请截图联系管理员:".JSON.stringify(res)
        }
      });
    }
  }
}
</script>
